import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="bg-brand-blue text-white py-6">
            <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm">
                <div className="text-center sm:text-left">
                    <span className="font-bold text-lg">reformista<span className="text-brand-yellow">.net</span></span>
                    <p className="text-gray-200">Transformamos oportunidades en valor.</p>
                </div>

                <div className="flex flex-wrap justify-center sm:justify-end gap-x-6 gap-y-2">
                    <Link to="/faq" className="hover:underline text-gray-100">
                        Preguntas Frecuentes
                    </Link>
                    <Link to="/contacto" className="hover:underline text-gray-100">
                        Contacto
                    </Link>
                    <a
                        href="/aviso-legal"
                        className="hover:underline text-gray-100"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Aviso Legal
                    </a>
                    <Link to="/api-docs" className="hover:underline text-gray-100">
                        Documentación API
                    </Link>
                    <Link to="/solicitar-api-key" className="hover:underline text-gray-100">
                        Solicitar API Key
                    </Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
